// import { Experiment } from 'storefront-nuxt-ab-testing'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type { Experiment } from '~/modules/ab-testing/experiment'

const useExperimentTracking = () => {
  const { ssrContext } = useNuxtApp()
  const req = ssrContext?.event.node?.req
  const route = useRoute()
  const { trackTriggerExperiment } = useTrackingEvents()

  const activeExperiments = useState<Experiment[]>(
    'activeExperiments',
    () => [],
  )

  if (import.meta.server && !activeExperiments.value.length) {
    activeExperiments.value =
      ((req as any).experiments as Experiment[])?.filter((i) => i.valid) || []
  }

  const triggerEvents = () => {
    for (const experiment of activeExperiments.value || []) {
      trackTriggerExperiment({
        experiment_name: experiment.name,
        experiment_variant: experiment.selectedVariant || '',
      })
    }
  }

  onMounted(triggerEvents)
  watch(() => route.fullPath, triggerEvents)
}

export default useExperimentTracking
